export const perPageList = [8, 16, 24];
export const doublePerPage = 24;
export const defaultPaginationProp = {
  per_page: 8,
  cursor: undefined
};

// Cursor pagination props
export interface CursorPaginationParams {
  per_page?: number;
  cursor?: string;
}

export interface CursorPaginationResponse<T> {
  next_cursor: string | null;
  previous_cursor: string | null;
  per_page: number;
  results: T[];
}
